import { Input, InputProps } from '@/components/ui/input';
import { useCommitOnBlurNumber } from './useCommitOnBlurNumber';

export function CommitOnBlurNumberInput({
  value,
  min,
  max,
  onCommit,
  ...props
}: {
  value: number;
  min?: number;
  max?: number;
  onCommit: (value: number) => void;
} & Omit<
  InputProps,
  'type' | 'value' | 'onChange' | 'onBlur' | 'onFocus' | 'onKeyDown'
>) {
  const commitProps = useCommitOnBlurNumber({
    value,
    min,
    max,
    onCommit,
  });

  return <Input type="number" {...props} {...commitProps} />;
}
